export enum BookingRelation {
  ALL = 'true',
  NONE = 'false'
}
